import {
    RxJsonSchema,
    toTypedRxJsonSchema,
    ExtractDocumentTypeFromTypedRxJsonSchema
} from 'rxdb';

export const PROGRAM_SCHEMA_LITERAL = {
    title: 'Program Schema',
    description: 'Shows the programs for a university',
    version: 0,
    keyCompression: false,
    primaryKey: {
        key: 'id',
        fields:[
            'program',
            'college',
            'study',
            'residency'
        ],
        separator: '|'
    },
    type: 'object',
    properties: {
        id:{
            type: 'string',
            maxLength: 300
        },
        study:{
            type: 'string',
            default: '',
            maxLength: 300
        },
        college:{
            type: 'string',
            default: '',
            maxLength: 200
        },
        program:{
            type: 'string',
            default: '',
            maxLength: 200
        },
        costInternational:{
            type: 'number',
            minimum: 0
        },
        costOutOfProvince:{
            type: 'number',
            minimum: 0
        },
        costDomestic:{
            type: 'number',
            minimum: 0
        },
        residency:{
            type: 'string',
            default: '',
            maxLength: 50
        },
        firstYearCost:{
            type: 'number',
            minimum: 0
        },
        bookSupplyCost:{
            type: 'number',
            minimum: 0
        },
        modifyCourseLoad:{
            type: 'boolean',
            default: true
        }
    },
    required:[
        'program',
        'college',
        'study',
        'residency'
    ],
    indexes: [
        ['study','residency'],
        ['study','college','residency'],
        ['study','college','residency','program']

    ]
} as const;

const schemaTyped = toTypedRxJsonSchema(PROGRAM_SCHEMA_LITERAL);
export type RxProgramDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const PROGRAM_SCHEMA: RxJsonSchema<RxProgramDocumentType> = PROGRAM_SCHEMA_LITERAL;